var _a;
import { AppointmentKind } from 'constants/appointmentKind';
import { noteType } from 'constants/ehrNoteEnums';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useNoteSchemaContext } from 'shared/features/note';
import { useFlagEnabled } from 'flagging/hooks';
import { useNoteSetupContext } from 'shared/features/note-setup';
import { useNoteForPathContext } from '../contexts';
var defaultNoteTypeByKind = (_a = {},
    _a[AppointmentKind.initialCareNavigation] = noteType.careNavigatorInitial,
    _a[AppointmentKind.followUpCareNavigation] = noteType.careNavigatorFollowUp,
    _a[AppointmentKind.therapy] = {
        first: noteType.adultTherapyIntake,
        other: noteType.adultTherapyFollowUp,
    },
    _a[AppointmentKind.minorTherapy] = {
        first: noteType.minorTherapyIntake,
        other: noteType.minorTherapyFollowUp,
    },
    _a[AppointmentKind.couplesTherapy] = {
        first: noteType.couplesFamilyTherapyIntake,
        other: noteType.couplesFamilyTherapyFollowUp,
    },
    _a[AppointmentKind.initialMedicationManagement] = noteType.adultMedManagementIntake,
    _a[AppointmentKind.followUpMedicationManagement] = noteType.adultMedManagementFollowUp,
    _a[AppointmentKind.initialMedicationManagementForMinor] = noteType.minorMedManagementIntake,
    _a[AppointmentKind.followUpMedicationManagementForMinor] = noteType.minorMedManagementFollowUp,
    _a);
export var useDefaultNoteType = function (appointment, formInitialized) {
    var _a = useState(false), initialized = _a[0], setInitialized = _a[1];
    var noteId = useNoteForPathContext().noteId;
    var setNoteType = useNoteSchemaContext().setNoteType;
    var setValue = useFormContext().setValue;
    var flagEnabled = useFlagEnabled('ENABLE_DEFAULT_NOTE_TEMPLATE');
    var defaultNoteTypeForKind = (appointment === null || appointment === void 0 ? void 0 : appointment.kind) in defaultNoteTypeByKind
        ? defaultNoteTypeByKind[appointment.kind]
        : null;
    var _b = useNoteSetupContext(), data = _b.data, isLoading = _b.isLoading;
    var hasHadKindBefore = (data !== null && data !== void 0 ? data : {}).hasHadKindBefore;
    useEffect(function () {
        if (defaultNoteTypeForKind && !isLoading && !noteId && formInitialized) {
            if (flagEnabled || typeof defaultNoteTypeForKind === 'string') {
                var defaultNoteType = typeof defaultNoteTypeForKind === 'string'
                    ? defaultNoteTypeForKind
                    : hasHadKindBefore
                        ? defaultNoteTypeForKind.other
                        : defaultNoteTypeForKind.first;
                setValue('sessionInfo.noteType', defaultNoteType);
                setNoteType(defaultNoteType);
            }
            setInitialized(true);
        }
        else {
            setInitialized(!!noteId || (!defaultNoteTypeForKind && !!appointment));
        }
    }, [defaultNoteTypeForKind, hasHadKindBefore, isLoading, formInitialized]);
    return {
        initialized: initialized,
    };
};
